import { State } from '../../reducers/rootReducer'

const trackingIsReadySelector = (state: State): boolean => state.trackingIsReady

export default trackingIsReadySelector
